export default __webpack_public_path__ + "static/media/gallery_d-min.11d5ce35.jpg";